import React, { useMemo } from "react";
import { observer } from "mobx-react-lite";
import { Hooks } from "@xt/xtbase";
import step6Img from "@/assets/img/cfd-guide/guide1.png";
import lineImg from "@/assets/img/cfd-guide/line.png";
import store from "store";
import { useCfdGuideStageRect } from "./useCfdGuideStageRect";
import styles from "./StandardGuideStep6.module.scss";

const { useTranslation } = Hooks;

export type StandardGuideStep6Props = {
  onSkip: () => void;
  onNext: () => void;
};

const DESIGN_WIDTH = 375;

function getScale(): number {
  if (typeof window === "undefined") return 1;
  const w = window.innerWidth || DESIGN_WIDTH;
  return w / DESIGN_WIDTH;
}

const StandardGuideStep6: React.FC<StandardGuideStep6Props> = ({ onSkip, onNext }) => {
  const t = useTranslation();

  const scale = useMemo(() => getScale(), []);

  const imgSrc = (step6Img as any)?.src || (step6Img as any);
  const lineImgSrc = (lineImg as any)?.src || (lineImg as any);

  const anchor = useCfdGuideStageRect('[data-guide-target="positionListTabs"]');

  return (
    <div style={{ ["--sg-scale" as any]: scale }}>
      <div
        className={styles.highlightAndTipWrapper}
        style={
          anchor
            ? {
                position: "fixed",
                top: anchor.top,
                left: anchor.left,
                width: anchor.width,
                zIndex: 10001,
              }
            : { visibility: "hidden" as const }
        }
      >
        <div className={styles.highlightRect} style={anchor ? { minHeight: anchor.height } : undefined}>
          <div className={styles.tabs}>
            <div className={`${styles.tab} ${styles.active}`}>
              <span className={styles.tabText}>{t("cfd.currentPositions")}(1)</span>
              <div className={styles.tabIndicator} />
            </div>
            <div className={styles.tab}>
              <span className={styles.tabText}>{t("cfd.currentOrders")}(1)</span>
            </div>
          </div>
        </div>
        <div className={styles.tip}>
        <div className={styles.tipBg}>
          <div className={styles.tipText}>
            <div className={styles.tipTitle}>{t("cfd.guide.standard.step6.title")}</div>
            <div className={styles.tipDesc}>{t("cfd.guide.standard.step6.desc")}</div>
          </div>
          <img className={styles.tipImg} src={imgSrc} alt="" />
        </div>
        <div className={styles.star1} />
        <div className={styles.star2} />
        <img className={styles.lineImg} src={lineImgSrc} alt="" />
      </div>
      </div>

      {/* 底部按钮 */}
      <div className={styles.btnGroup}>
        <button type="button" className={`${styles.btn} ${styles.btnPrimary}`} onClick={onNext}>
          {`${t("cfd.guide.next")} 6/7`}
        </button>
        <button type="button" className={`${styles.btn} ${styles.btnGhost}`} onClick={onSkip}>
          {t("cfd.guide.skip")}
        </button>
      </div>
    </div>
  );
};

export default observer(StandardGuideStep6);
